module.exports = __webpack_public_path__ + "img/spci.14d83ef8.svg";